<div class="story-item" 
     (mouseover)="changeHoverColor()"
     (mouseout)="resetHoverColor()" 
     [ngClass]="{'inbound': story.type === 'inbound', 'story': story.type != 'inbound', 'no-thumb': !story.media?.length}" 
     role="article" 
     [attr.aria-labelledby]="'story-title-' + story.id">
  <div class="story-item__wrap">
    <div class="row align-items-center">
      <div class="col-12">
        <div class="story-item__header" 
             [style.background]="GuestLables ? GuestLables : ''" 
             [style.color]="guest_label_text ? guest_label_text : ''"
             *ngIf="story.type === 'inbound' && story?.authorInboundType && GuestLables  && story?.companyIdSlug != 'dress-for-success-houston' && enable_labels">
          <div class="blurb">From {{story.authorInboundType}}</div>
        </div>
        <div class="story-item__header" 
             [style.background]="userLables ? userLables : ''" 
             [style.color]="user_label_text ? user_label_text : ''"
             *ngIf="story.type != 'inbound' && story?.authorInboundType && userLables  && story?.companyIdSlug != 'dress-for-success-houston' && enable_labels">
          <div class="blurb">From {{story.authorInboundType}}</div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3">
        <div data-btn [routerLink]="href" [queryParams]="queryParamsDeatil(story)" *ngIf="story.media && story.media.length && story.media[0].type.indexOf('video') === -1"
          class="story-item__thumb">
          <img [ngClass]="{'dfsimg':story?.companyIdSlug == 'dress-for-success-houston'}"  [src]="story.media[0].fullsize == 'https://images.goodseeker.com/goodseeker/mediafiles/company/1602/story-image/f3705dc9-b04e-4ce0-a6ef-ff629a37ed27.png?tr=n-full_size' ? 'https://images.goodseeker.com/goodseeker/mediafiles/company/1602/story-image/c31a3367-581e-4c48-b12d-507a48830c08.png?tr=n-full_size': story.media[0].fullsize " />
        </div>
        <div data-btn 
             [routerLink]="href" 
             [queryParams]="queryParamsDeatil(story)" 
             *ngIf="story.media && story.media.length && story.media[0].type.indexOf('video') > -1"
             class="story-item__video">
          <img [ngClass]="{'dfsimg':story?.companyIdSlug == 'dress-for-success-houston'}" [src]="getUrl(story.media[0])" 
               alt="'Video thumbnail for' + story.title + 'by' + story.author.displayName" />
        </div>
      </div>
      <div class="col-lg-9 col-md-8 align-self-end">
        <div class="story-item__conts">
          <h2 class="story-item__title" 
              id="story-title-{{story.id}}" 
              data-btn 
              [ngClass]="{'dfstitle': story?.companyIdSlug == 'dress-for-success-houston'}"
              [routerLink]="href" 
              [queryParams]="queryParamsDeatil(story)" 
              tabindex="0"> <!-- Added tabindex for keyboard accessibility -->
            {{story.title}}
          </h2>
          <div class="story-item__info">
            <div class="story-item__user px-0 col-12">
              <gs-avatar [src]="getauthor(story?.author?.avatar)" 
                         isBackground="true" 
                         classCss="avatar avatar--xs" 
                         [alt]="story.author.displayName">
              </gs-avatar>
              <div class="name text-nowrap">{{story.author.displayName}}</div>
            </div>
          </div>
          <div class="story-item__tags" [ngClass]="{'dfsnotags':story?.companyIdSlug == 'dress-for-success-houston', 'd-lg-block':story?.companyIdSlug != 'dress-for-success-houston' && enable_labels }" *ngIf="story.highlightTags">
            <a *ngFor="let tag of story.highlightTags" 
               href="javascript:void(0)" 
               class="tag" 
               [style.color]="tag.color" 
               tabindex="0"> <!-- Added tabindex for keyboard accessibility -->
              #{{tag.text}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="story-item__detail" 
  (mouseover)="changeHoverColor()"
  (mouseout)="resetHoverColor()" 
  [style.backgroundColor]="dynamicHoverColor">

<a [routerLink]="href" 
  [queryParams]="queryParamsDeatil(story)" 
  [attr.aria-label]="'Read more about ' + story.title + ' by ' + story.author?.displayName">

 <div class="story-item__detail-wrap">

   <!-- DESCRIPTION -->
   <div class="story-item__detail-desc">

     <!-- Interview Content -->
     <ng-container *ngIf="story?.interview_content?.length > 0; else normalContent">

       <!-- Question -->
       <p class="question">
         {{ story.interview_content[0]?.question }}
       </p>

       <!-- Answer (3 lines only; hide on no-image tiles — overlay is too short) -->
       <p class="answer clamp-3" *ngIf="story.media?.length">
         {{ story.interview_content[0]?.body | stripHtml }}
       </p>

     </ng-container>

     <!-- Normal Content -->
     <ng-template #normalContent>
       <p>
         {{ story.content | stripHtml }}
       </p>
     </ng-template>

   </div>

   <!-- CONTRIBUTORS -->
   <!-- <div class="story-item__detail-player" *ngIf="story.contributors">
     <div class="player-item" *ngFor="let player of story.contributors">
       <div class="player-item__avatar">
         <gs-avatar 
           [src]="player.avatar" 
           [title]="player.displayName" 
           isBackground="true"
           classCss="avatar avatar--md" 
           [alt]="player.displayName">
         </gs-avatar>
       </div>
     </div>
   </div> -->

   <!-- READ MORE -->
   <div class="story-item__detail-more">
     <a class="btn btn-white btn-md btn-outline" 
        role="button" 
        tabindex="0">
       Read More
     </a>
   </div>

 </div>

</a>
</div>
</div>